import React, {useContext, useEffect, useRef, useState} from 'react';
import {UsePermissions} from "../../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {getData, getInfoContrato, eliminarContrato} from "../../../api/contrato.service";
import {convertirModena, exportExcel, formatFecha} from "../../../shared/utils/utils";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
import {AppContext} from "../../../context/appContext";
import {confirmDialog} from "primereact/confirmdialog";
import {UseLoader} from "../../../hooks/useLoader";

export const TableContrato = ({obtenerParametrosContrato, nuevoContrato, reload, asociadosContrato}) => {

    const [permisos] = UsePermissions()
    // parametros de la tabla
    const [handleLoad] = UseLoader();
    const initParaminfoGenContratos = {
        contrato: '',
        cliente: '',
        disponible: '',
        valor_facturado: '',
        valorTotal: ''
    }
    const [infoGenContratos, setInfoGenContratos] = useState(initParaminfoGenContratos);

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);
    const [contratos, setcontratos] = useState([]);
    const {user} = useContext(AppContext);
    const toast = useRef(null);
    const initParams = {
        first: 0,
        rows: 50,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'contratomarco_id': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'nombre': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'codigo': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'valor_bruto': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'tipo': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
            'fecha_ini': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
            'fecha_fin': {operator: FilterOperator.OR, constraints: [{value: '', matchMode: FilterMatchMode.EQUALS}]},
        }
    };

    const [lazyParams, setLazyParams] = useState(initParams);
    const valorMinimo = 1000000;

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const loadInfoContractPromise = async () => {
        const response = await getInfoContrato({contratomarcoId: user.contratomarcoId});
        return await response.data;
    }

    const loadInfoContract = () => {
        loadInfoContractPromise().then(r => {
                const response = r.data.infoContrato;
                setInfoGenContratos({
                    ...infoGenContratos,
                    valorTotal: response?.valorTotal,
                    disponible: response?.disponible,
                    cliente: response?.cliente,
                    valor_facturado: response?.valor_facturado,
                    contrato: response?.contrato
                });
            }
        );

    }


    const onDelete = (contratoId) => {
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {

                handleLoad(true);
                const response = await eliminarContrato(contratoId);

                handleLoad(false)

                if (response.estado !== 200) {
                    toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                window.location.reload()
            }
        });
    }


    const loadLazyData = () => {

        setLoading(true);

        init({lazyEvent: lazyParams, contratomarcoId: user.contratomarcoId}).then(data => {
            // record
            setTotalRecords(data.total);
            // total
            setcontratos(data.record);
            setLoading(false);
        })
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    useEffect(() => {
        if (user.contratomarcoId !== '' && user.contratomarcoId !== null) {
            loadLazyData();
        }
        return () => {
            // record
            setTotalRecords(0);
            // total
            setcontratos([]);

        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload) {
            if (user.contratomarcoId !== '' && user.contratomarcoId !== null) {
                loadLazyData();
                loadInfoContract();
            }
        }
        return () => {
            // record
            //setTotalRecords(0);
            // total
            // setcontratos([]);
            //setInfoGenContratos(initParaminfoGenContratos)
        }
    }, [reload]);

    useEffect(() => {

        if (user.contratomarcoId != null && user.contratomarcoId !== undefined && user.contratomarcoId !== "") {

            loadLazyData();
            loadInfoContract();
        }

        return () => {

            setTotalRecords(0);
            // total
            setcontratos([]);

        };
    }, [user]);

    const tipo = [
        {
            name: "Inicial",
            value: "I"
        },
        {
            name: "Adicion",
            value: "O"
        }
    ];

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option.value}`}>{option.name}</span>;
    }

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={tipo}
                         onChange={(e) => options.filterCallback(e.value, options.index)}
                         optionLabel="name"
                         itemTemplate={statusItemTemplate}
                         placeholder="Seleccione un estado" className="p-column-filter"
                         showClear/>;
    }

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)}
                         dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999"/>
    }

    const dateFinFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)}
                         dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999"/>
    }
    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevoContrato}
                >
                    <i className="fa fa-file-text"/>
                </button>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>
                <button
                    onClick={() => exportExcel(contratos, "contratos")}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-print"/>
                </button>
            </div>

        </div>
    );

    const footer = (
        <div className="flex align-items-center justify-evenly ">
            <p className="p-2  text-sm">Valor total: {convertirModena(infoGenContratos.valorTotal)}</p>
            <p className="p-2  text-sm"> Facturado: {convertirModena(infoGenContratos.valor_facturado)}</p>
            <p className={parseInt(infoGenContratos.disponible) > valorMinimo ? 'p-2 ext-sm text-teal-600' : 'p-2  text-sm text-red-600'}>Disponible: {convertirModena(infoGenContratos.disponible)}</p>
        </div>
    );

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosContrato(rowData)}>
                    <i className="fa fa-edit"/>
                </button>
                <button
                    className="danger-color-btn btn"
                    type="button"
                    disabled={(!permisos.eliminar)}
                    onClick={() => onDelete(rowData.contratomarco_id)}
                >
                    <i className="fa fa-trash"/>
                </button>
            </div>
        );
    }


    const valueBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_bruto);
    }

    const dateIniBodyTemplate = (rowData) => {
        return formatFecha(rowData.fecha_ini)
    }
    const dateFinBodyTemplate = (rowData) => {
        return formatFecha(rowData.fecha_fin)
    }

    const agregarOeditarAsociados = () => (
        <div className="flex flex-wrap justify-between w-full">

            <div>
                <p className="ml-2 md:ml-0">{infoGenContratos.cliente} - {infoGenContratos.contrato}</p>
            </div>
            <div className="md:ml-8 mt-2 md:mt-0">
                <button className="ml-2 btn primary-color-btn"
                        onClick={() => asociadosContrato( `${infoGenContratos.contrato} - ${infoGenContratos.cliente}`)}>
                      Agregar
                    / descartar afiliados
                </button>
            </div>
        </div>
    );
    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {(infoGenContratos.cliente ? agregarOeditarAsociados() : permisos.submenu)}
            </ContainerTitleTable>
            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    footer={footer}
                    resizableColumns
                    columnResizeMode="expand"

                    size="small"
                    value={contratos}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    paginator
                    rows={rowInit}
                    rowsPerPageOptions={[50, 100, 300, 500]}
                    scrollable scrollHeight="500px"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} contratos"
                    responsiveLayout="scroll">

                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}/>

                    <Column field="codigo" header="UCC" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>
                    <Column field="tipo" header="Tipo" sortable filter
                            filterElement={statusFilterTemplate} showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>
                    <Column field="fecha_ini" header="Fecha inicial" body={dateIniBodyTemplate} sortable filter
                            showFilterMatchModes={false}
                            filterElement={dateFilterTemplate}
                            dataType="date"
                            onFilterClear={laziParamsInit}/>
                    <Column field="fecha_fin" header="Fecha Final" body={dateFinBodyTemplate} sortable filter
                            dataType="date"
                            filterElement={dateFinFilterTemplate}
                            showFilterMatchModes={false}

                            onFilterClear={laziParamsInit}/>
                    <Column field="valor_bruto" body={valueBodyTemplate} header="Valor bruto" sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>
                </DataTable>
            </ContainerTable>
        </>
    );
};

